/** Workplace settings (MZČR tab) – where the certificate is uploaded. */
export const MZCR_SETTINGS_URL = '/pracoviste/settings?activeTab=mzcr';

/** Reloads the PHP session ACL after the workplace certificate was uploaded (POST). */
export const MZCR_REFRESH_ACL_URL = '/docasne-uloziste/obnovit-opravneni';
